/*******************************************************************************
FIX ALL WIDOWS
Widows occur when a sentence has the last word hanging out by itself on a line.
This should fix that problem for any selectors matched by inserting a non-breaking space in between the last two words.
Found here: http://justinhileman.info/article/a-jquery-widont-snippet/
*******************************************************************************/

export default function fixAllWidows() {
    $('.article__headline, .table-paywall__headline, .compact-article__link, .featured-article__title, .featured-article__desc, .compact-article__link div').each((index, element) => {
        const newHTML = $(element).html().replace(/\s((?=(([^\s<>]|<[^>]*>)+))\2)\s*$/, '&nbsp;$1');
        $(element).safehtml(newHTML);
    });
}
